var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCricket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.006 16.43c.84-.96 1.719-1.92 2.64-2.798 16.314.813 31.113 6.708 42.996 16.119l-.156-.12c13.839 11.589 24.615 26.385 31.23 43.272l.252.729a43 43 0 0 1-2.514 3.663l.075-.102c-6.846-16.476-16.95-30.378-29.592-41.451l-.129-.111a83.25 83.25 0 0 0-44.415-19.164zm-6.279 8.8c17.289.786 32.922 7.29 45.192 17.652l-.111-.093c12.516 11.1 22.29 25.014 28.359 40.764l.243.714C71.043 91.539 60.039 95.97 48 95.97c-26.511 0-48-21.49-48-48a47.8 47.8 0 0 1 5.856-22.995l-.126.252zM25.725 5.51C32.184 2.059 39.855.03 48 .03c26.511 0 48 21.489 48 48 0 4.98-.759 9.786-2.166 14.3l.09-.338C86.553 46.056 76.101 32.685 63.24 22.149l-.195-.156C52.626 13.785 39.948 7.968 26.097 5.583l-.492-.07z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCricket);
export default __webpack_public_path__ + "static/media/cricket.1246d1079ea63e647de1ac4747c3b0cf.svg";
export { ForwardRef as ReactComponent };